import React, { useState } from 'react'
import Label from '../../../../components/common-components/label/Label'
import Heading from '../../../../components/common-components/heading/Heading'
import { HEADING } from '../../../../components/common-components/heading/Constants'
import Button from '../../../../components/common-components/button/Button'
import { BUTTON_VARIANTS } from '../../../../components/common-components/button/Constants'
import Table from '../../../../containers/Table/Index'
import LabOrderModal from './LabOrderModal'
import LabOrderPrintModal from './laborderprint/LabOrderPrintModal'
import { MET_COLORS } from '../../../../libs/constant'
import ButtonDropdown from '../../../../components/common-components/buttonDropdown'
import LabResultModal from './LabResultModal'

function LabOrder() {
    const [isLabResultModalOpen, setIsLabResultModalOpen] = useState(false)
    const [isLabOrderModalOpen, setIsLabOrderModalOpen] = useState(false)
    const [isLabPrintModalOpen, setIsLabPrintModalOpen] = useState(false)

    const handleAddResultClick = () => {
        setIsLabResultModalOpen(true);
    };

    const handleLabOrderModal = () => {
        setIsLabOrderModalOpen(true)
    }

    const handleLabOrderModalClose = () => {
        setIsLabOrderModalOpen(false)
    }
    const coloumns = [
        {
            field: "referenceID",
            label: <Label>Lab Reference ID</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.referenceID}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "appointment",
            label: <Label>Appointment</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.appointment}</Heading>
                            <Label color='gray-500'>{row.subLabel}</Label>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "labCenter",
            label: <Label>Lab Center</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.labCenter}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "orderingProvider",
            label: <Label>Ordering Doctor</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.orderingProvider}</Heading>
                        </div>
                    </div>
                </>
            },
        },

        {
            field: "date",
            label: <Label>Date</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.date}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "testDesc",
            label: <Label>Test Description</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.testDesc}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "reqForm",
            label: <Label>Requisition Form</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.reqForm}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "status",
            label: <Label>Status</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.status}</Heading>
                        </div>
                    </div>
                </>
            },
        },
        {
            field: "action",
            label: <Label>Action</Label>,
            renderLogic: (row) => {
                return <>
                    <div className='flex items-center'>
                        <div>
                            <Heading type={HEADING.H1} color='gray-500' fontSize={"md"} customClasses="cursor-pointer">{row.action}</Heading>
                        </div>
                        <ButtonDropdown customBtnClass="p-0" endIcon="moreVertIcon" options={[{ label: "Add Result", value: null, onClickCb: handleAddResultClick }, { label: "Edit Order", value: null }, { label: "Print Order", value: null }, { label: "Mark As Completed", value: null }, { label: "Cancel Order", value: null },]} />
                    </div>
                </>
            },
        },
    ]

    const rowData = [
        {
            referenceID: '#917937',
            appointment: 'Fri Mar 21, 2022',
            subLabel: '02:30 PM',
            labCenter: 'Pathology Laboratories',
            orderingProvider: 'Theodore Payne',
            date: '04-10-2022',
            testDesc: '1. Erythrocyte sedimentation rate (ESR) test',
            reqForm: 'Fri Mar 21, 2022 (Fax)',
            status: 'sent',
        },
        {
            referenceID: '',
            appointment: '',
            subLabel: '',
            labCenter: '',
            orderingProvider: '',
            date: '',
            testDesc: '2. C-reactive protein (CRP) blood test',
            reqForm: '',
            status: '',
        },
        {
            referenceID: '#917937',
            appointment: 'Mon Mar 30, 2022',
            subLabel: '03:30 PM',
            labCenter: 'Sonic Healthcare',
            orderingProvider: 'Annie Cooper',
            date: '04-10-2022',
            testDesc: '1.Hemoglobin A1c/Hemoglobin total in Blood',
            reqForm: 'Requisition Form',
            status: 'Draft',
        },
        {
            referenceID: '#917937',
            appointment: 'Thu Apri 15, 2022',
            subLabel: '02:00 PM',
            labCenter: 'Randox Laboratories',
            orderingProvider: 'Jessica James',
            date: '04-10-2022',
            testDesc: '1.Hemoglobin A1c/Hemoglobin total in Blood',
            reqForm: 'Jessica James',
            status: 'Completed',
        },
    ]
    return (
        <>
            <div className='flex items-center justify-end px-4 p-2'>
                <div className='flex'>
                    <Button onClickCb={handleLabOrderModal} variant={BUTTON_VARIANTS.OUTLINED} startIcon={{ icon: "plusVectorIcon", color: MET_COLORS.PRIMARY }} >Add Lab Orders</Button>
                </div>
            </div>
            <div className='p-4'>
                <Table isPagination={false} coloumns={coloumns} rows={rowData} sorting={
                    {
                        isSortable: false,
                        onSortChangeCb: () => { }
                    }} />
            </div>
            {isLabResultModalOpen ? <LabResultModal open={isLabResultModalOpen} close={() => setIsLabResultModalOpen(false)} /> : null}
            {isLabOrderModalOpen && <LabOrderModal open={isLabOrderModalOpen} close={handleLabOrderModalClose} onClickCb={() => {
                setIsLabOrderModalOpen(false)
                setIsLabPrintModalOpen(true)
            }} />}
            {isLabPrintModalOpen && <LabOrderPrintModal open={isLabPrintModalOpen} close={() => {
                setIsLabPrintModalOpen(false)
            }} />}
        </>
    )
}

export default LabOrder
